module.exports = __webpack_public_path__ + "img/rin kaenbyou.3bd7b1d0.png";